import ReactSelect from '../ReactSelect';
import React from 'react';
import { AssignmentStatus } from '../../types/assignment';

export type StatusOption = { value: AssignmentStatus; label: string };

export const statusIsOpen = (option: StatusOption) => {
  return statusOptions
    .find((group) => group.label === 'Open')
    ?.options.find((opt) => opt.value === option.value);
};

export const statusIsClosed = (option: StatusOption) => !statusIsOpen(option);

export const statusOptions: {
  label: string;
  options: StatusOption[];
}[] = [
  {
    label: 'Open',
    options: [
      {
        value: 'OPEN',
        label: 'All Open',
      },
      {
        value: 'NEW',
        label: 'New',
      },
      {
        value: 'ASSIGNED',
        label: 'Assigned',
      },
      {
        value: 'FOLLOW_UP',
        label: 'Follow Up',
      },
      {
        value: 'COMPLETED',
        label: 'In Review',
      },
    ],
  },
  {
    label: 'Closed',
    options: [
      {
        value: 'CLOSED',
        label: 'All Closed',
      },
      {
        value: 'SUBMITTED',
        label: 'Submitted',
      },
      {
        value: 'CANCELED',
        label: 'Canceled',
      },
    ],
  },
] as const;

export const JobStatusPicker = ({
  value,
  onChange,
}: {
  value?: AssignmentStatus[];
  onChange?: (newValue?: AssignmentStatus[]) => void;
}) => {
  const selectedStatuses: StatusOption[] = [];

  if (Array.isArray(value)) {
    statusOptions.forEach((group) =>
      selectedStatuses.push(
        ...group.options.filter((option) => value?.includes(option.value))
      )
    );
  }
  return (
    <ReactSelect
      placeholder="status"
      isMulti
      isClearable={false}
      onChange={(values, meta) => {
        if (Array.isArray(values)) {
          if (meta.action === 'select-option' && meta.option) {
            if (statusIsOpen(meta.option)) {
              if (meta.option.value === 'OPEN') {
                values = values.filter((option) => option.value === 'OPEN');
              } else {
                values = values.filter((option) => option.value !== 'OPEN');
              }
            } else if (statusIsClosed(meta.option)) {
              if (meta.option.value === 'CLOSED') {
                values = values.filter((option) => option.value === 'CLOSED');
              } else {
                values = values.filter((option) => option.value !== 'CLOSED');
              }
            }
          }
          onChange?.(
            values.length > 0 ? values.map((value1) => value1.value) : undefined
          );
        } else {
          onChange?.(undefined);
        }
      }}
      value={selectedStatuses}
      options={statusOptions}
    />
  );
};
